var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    notification: true,
    hide: !_vm.notification.show,
    disabled: _vm.notification.isLoading
  },on:{"click":_vm.loadData}},[_c('i',{class:{ 'fas fa-sync': true, 'fa-spin': _vm.notification.isLoading }}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.notification.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff236c5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dispatch/NotificationNewBooking.vue
// module id = 1286
// module chunks = 0